Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleInstagrmLoad = void 0;
var _utils = require("../../utils");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var instgrmEmbedUrl = "https://www.instagram.com/embed.js";
var instgrmProcess = function instgrmProcess() {
  if (_typeof(window.instgrm) !== "undefined" && window.instgrm.Embeds && _typeof(window.instgrm.Embeds.process) === "function") {
    window.instgrm.Embeds.process();
  }
};
var handleInstagrmLoad = function handleInstagrmLoad() {
  if (!window.instgrm) {
    (0, _utils.createScriptTag)(instgrmEmbedUrl, null);
    return {
      status: 'createScriptTag'
    };
  } else {
    instgrmProcess();
    return {
      status: 'instgrmProcess'
    };
  }
};
exports.handleInstagrmLoad = handleInstagrmLoad;